import intersection from 'lodash-es/intersection'
import uniq from 'lodash-es/uniq'

/**
 * Sorts item tags based on user search criteria
 * @param {String} searchTerm the search term the user has chosen
 * @param {Array} searchedTags the tags the user has elected to search for
 * @param {Array} itemTags the tags associated with an item
 * @returns {Array} item tags sorted according to relevance
 */
export const sortTagsAccordingToRelevance = (
  searchTerm: string[] = [],
  searchedTags: string[] = [],
  itemTags: string[] = []
): string[] =>
  uniq([
    ...intersection(itemTags, searchTerm),
    ...intersection(itemTags, searchedTags),
    ...itemTags.sort()
  ])
